import { loadStripe } from "@stripe/stripe-js";

const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.trim();

if (process.env.NODE_ENV === "production" && !key) {
  console.error(
    "REACT_APP_STRIPE_PUBLISHABLE_KEY is missing; Stripe Checkout will not work until it is set at build time."
  );
} else if (process.env.NODE_ENV !== "production" && !key) {
  console.warn(
    "REACT_APP_STRIPE_PUBLISHABLE_KEY is not set; set it in .env.local for Stripe."
  );
}

export const stripePublishableKey = key || "";

export const stripePromise = key ? loadStripe(key) : null;
